"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardTiles = BoardTiles;
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const context_1 = require("./context");
const Tile_1 = require("./tile/Tile");
const useBoardStyles = (0, react_jss_1.createUseStyles)({
    board: {
        position: "absolute",
        width: "100%",
        height: "100%",
        display: "grid",
        gridTemplateColumns: (props) => `repeat(${props.size.width}, 1fr)`,
        gridTemplateRows: (props) => `repeat(${props.size.height}, 1fr)`,
        gridColumnGap: 0,
        gridRowGap: 0,
    },
});
// eslint-disable-next-line no-bitwise
const isBoardTileDark = (x, y) => ((y ^ x) & 1) !== 0;
function BoardTiles({ lightTileClassName, darkTileClassName, onClick, }) {
    const board = (0, context_1.useBoardState)();
    const styles = useBoardStyles({
        size: { width: board.width, height: board.height },
    });
    const tiles = react_1.default.useMemo(() => {
        const t = [];
        for (let y = 0; y < board.height; y++) {
            for (let x = 0; x < board.width; x++) {
                t.push(react_1.default.createElement(Tile_1.Tile, { key: `tile-${x}-${y}`, x: x, y: y, onClick: onClick, className: isBoardTileDark(x, y) ? darkTileClassName : lightTileClassName }));
            }
        }
        return t;
    }, [
        darkTileClassName,
        lightTileClassName,
        onClick,
        board.height,
        board.width,
    ]);
    return react_1.default.createElement("div", { className: styles.board }, tiles);
}
